// src/hooks/useDeleteHandler.ts
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { App as AntdApp } from 'antd';

export const useDeleteHandler = () => {
  const navigate = useNavigate();
  const { message } = AntdApp.useApp();

  return useCallback(
    async ({
      id,
      entityName,
      deleteApi,
      onSuccess,
      redirectPath,
    }: {
      id: string;
      entityName: string;
      deleteApi: (id: string) => Promise<any>;
      onSuccess?: () => void;        // optional callback for grid refresh etc.
      redirectPath?: string;         // optional: e.g. '/roles'
    }) => {
      try {
        await deleteApi(id);
        message.success(`${entityName} deleted successfully`);

        if (onSuccess) {
          onSuccess();
        } else if (redirectPath) {
          navigate(redirectPath);
        }
      } catch (error) {
        message.error(`Failed to delete ${entityName}`);
        console.error(error);
      }
    },
    [navigate, message]
  );
};
